import React from "react";

const NoticeMsg = ({ notice, msg }) => {
  
  let bg;

  switch (notice) {
    case "error":
      bg = "bg-red-100 ring-red-400 text-red-600";
      break;

    case "success":
      bg = "bg-green-100 ring-green-400 text-green-600";
      break;

    default:
      break;
  }

  return (
    <div
      className={`w-full ${bg} h-auto rounded-lg flex items-center p-3 ring-2`}
    >
      <span>{msg}</span>
    </div>
  );
};

export default NoticeMsg;
